import { useEffect } from 'react';
import { createBrowserRouter } from 'react-router';
import { SiteLayout } from './SiteLayout.tsx';
import { HomePage } from './HomePage.tsx';
import { AboutPage } from './AboutPage.tsx';
import { PublicNoticesPage, PublicNoticePage } from '../pages/notices/PublicNoticesPages.tsx';
import { appOrigin } from '../lib/hosts.ts';

/** 사이트가 모르는 경로(옛 앱 링크·메일의 /app/invite/…, 북마크 /evidence)는 앱 호스트로 보낸다 (CR-031 → CR-040: /app 접두어 제거) */
function LegacyRedirect() {
  useEffect(() => { const { pathname, search, hash } = window.location; window.location.replace(`${appOrigin()}${pathname.replace(/^\/app(?=\/|$)/, '') || '/'}${search}${hash}`); }, []);
  return null;
}

/** 서비스 사이트 라우터 (CR-031). 앱 라우터(router.tsx)와는 별개이며 main.tsx 가 호스트로 고른다 (CR-040) */
export function createSiteRouter() {
  return createBrowserRouter([
    { path: '/', Component: SiteLayout, children: [
      { index: true, Component: HomePage },
      { path: 'about', Component: AboutPage },
      { path: 'notices', Component: PublicNoticesPage },
      { path: 'notices/:id', Component: PublicNoticePage },
    ] },
    { path: '*', Component: LegacyRedirect },
  ]);
}
